var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "share-story-container" }, [
    _c("div", { staticClass: "share-story-content" }, [
      _c("p", [
        _vm._v(_vm._s(`${_vm.$t("buttons.showcase")}`)),
        _c("br"),
        _vm._v(_vm._s(`${_vm.$t("buttons.helpDriveSales")}`))
      ]),
      _c("div", { staticClass: "button-wrapper" }, [
        _c("button", { on: { click: _vm.goToSubmissionForm } }, [
          _c("span", { staticClass: "not-mobile" }, [
            _vm._v(_vm._s(`${_vm.$t("buttons.shareStory")}`))
          ]),
          _c("span", { staticClass: "mobile" }, [
            _vm._v(_vm._s(`${_vm.$t("buttons.share")}`))
          ]),
          _c("img", {
            attrs: {
              src: require("@/drc/assets/icons/arrows/arrow-top-right.svg"),
              alt: ">"
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }